import { useLayoutEffect, useRef, useState } from 'react';

interface RollingNumberProps {
    value: string;
}

export function RollingNumber({ value }: RollingNumberProps) {
    const prevRef = useRef(value);
    const [previous, setPrevious] = useState<string | null>(null);

    useLayoutEffect(() => {
        if (prevRef.current !== value) {
            setPrevious(prevRef.current);
            prevRef.current = value;
        }
    }, [value]);

    return (
        <span className="rolling-number relative inline-flex overflow-hidden">
            <span
                key={value}
                className={previous !== null ? 'animate-roll-up-in' : undefined}
            >
                {value}
            </span>
            {previous !== null && (
                <span
                    aria-hidden
                    className="absolute inset-0 animate-roll-up-out"
                    onAnimationEnd={() => setPrevious(null)}
                >
                    {previous}
                </span>
            )}
        </span>
    );
}
